// ISCC EU raw material types for the inbound forms and filters — no endpoint serves them.
// TODO: localise the labels if the compliance domain ever needs it.
export const RAW_MATERIAL_TYPES = Object.freeze([
  'Algae',
  'Animal by-products (category 1)',
  'Animal by-products (category 2)',
  'Animal by-products (category 3)',
  'Animal by-products (uncategorized)',
  'Animal fats from rendering (category 1)',
  'Animal fats from rendering (category 2)',
  'Animal fats from rendering (category 3)',
  'Animal fats from rendering (uncategorized)',
  'Bagasse',
  'Barley',
  'Black liquor',
  'Brown grease / grease trap fat',
  'Brown liquor/ spent sulphite liquor',
  'Camelina',
  'Cashew Nut Shell Liquid (CNSL)',
  'Castor seed',
  'Champost',
  'Corn / Maize',
  'Corn / Maize cobs',
  'Cotton',
  'Cotton seed',
  'Croton seed',
  'Crude glycerine',
  'Crude tall oil (CTO)',
  'Draff',
  'Empty Palm Fruit Bunch (EFB) oil',
  'Empty Palm Fruit Bunches (EFB)',
  'Ethanol used in the cleaning/extraction of blood plasma',
  'Ethanol used in the extraction of ingredients from medicinal plants',
  'Feed waste',
  'Fish Oil Ethyl Esther (FOEE)',
  'Flower bulbs',
  'Food waste',
  'Forestry processing residues',
  'Forestry residues',
  'Fruit tree cuttings (from agriculture)',
  'Giant cane',
  'Grape marc',
  'Grass',
  'Grass fiber residues from the production of grass protein',
  'Husks',
  'Intermediate crop (specification of crop)',
  'Jatropha',
  'Linseed/Flaxseed',
  'Manure',
  'Matter Organic Non-Glycerol (MONG)',
  'Municipal grass cuttings',
  'Mustard/Carinata',
  'Nut shells (specification of nut)',
  'Oat',
  'Oil Palm Fresh Fruit Bunches (FFBs)',
  'Olives',
  'Organic municipal solid waste (MSW)',
  'Out of shelf-life disinfectant',
  'Palm Fatty Acid Distillate (PFAD)',
  'Palm kernel shells (PKS)',
  'Palm oil mill effluent (POME) oil',
  'Pongamia seed',
  'Pot ale',
  'Poultry feather acid oil',
  'Pressed palm fiber oil',
  'Rapeseed/canola',
  'Biogenic fraction of end-of-life tyres',
  'Residue of FAME end distillation',
  'Residues from the processing of corn/maize',
  'Rye',
  'Safflower/Carthame seed',
  'Sewage sludge',
  'Shea nuts',
  'Short Rotation Coppice',
  'Soapstock acid oil contaminated with sulphur',
  'Sorghum',
  'Soybean',
  'Spent bleaching earth',
  'Starch slurry (low grade)',
  'Straw',
  'Sugar beet',
  'Sugar beet betaine residue',
  'Sugar beet residues',
  'Sugarcane',
  'Sunflower',
  'Tall oil pitch',
  'Technical corn oil',
  'Tiger nuts / Chuffa',
  'Transesterification residues (TER)',
  'Triticale',
  'Unrefined liquid dextrose ultrafiltration retentate',
  'Used cooking oil (UCO) entirely of veg. origin',
  'Used cooking oil (UCO)',
  'Waste pressings from production of vegetable oils',
  'Waste starch slurry',
  'Waste starch slurry from distillation of grain mixtures',
  'Wastewater from ship transport',
  'Waste oil from sewage sludge treatment',
  'Waste wood',
  'Waste / residues from processing of alcohol',
  'Waste / residues from processing of vegetable or animal oil',
  'Wet corn fiber',
  'Wheat',
  'Whey permeate',
  'Wine lees',
  'Woody biomass fraction of non-recyclable industrial and municipal construction',
  'Other:Specify here individually',
]);

export const buildRawMaterialTypeOptions = () =>
  RAW_MATERIAL_TYPES.map((name) => ({ value: name, label: name }));
